(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("4LSXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6380d2989ec014a0$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $gDdCy = parcelRequire("gDdCy");
// window.transactionOrder arrives in two shapes: the REST API order (billing.*,
// total_tax, shipping_total) and a flattened one (tax, shipping, no billing).
// Reads tolerate both; the REST `shipping` is an address object, hence || 0.
const $6380d2989ec014a0$var$woocommerceDataSource = ()=>{
    if (!window.transactionOrder) return;
    try {
        var _transaction_billing, _transaction_billing1, _transaction_billing2, _transaction_billing3;
        const transaction = (0, $gDdCy.tryParseJSONObject)(window.transactionOrder);
        const products = (0, $gDdCy.tryParseJSONObject)(window.transactionItems);
        if (!Array.isArray(products)) return;
        const total = parseFloat(transaction.total);
        if (Number.isNaN(total)) // logger.error("WooCommerce: unparseable transaction total", transaction.total);
        return;
        var _transaction_id, _ref;
        // Order key varies: id, transaction_id, or customer-facing number. Without
        // one the event can't be deduped or joined — skip instead of throwing.
        const transactionId = (_ref = (_transaction_id = transaction.id) !== null && _transaction_id !== void 0 ? _transaction_id : transaction.transaction_id) !== null && _ref !== void 0 ? _ref : transaction.number;
        if (transactionId === undefined || transactionId === null) // logger.error("WooCommerce: transaction payload has no order id", transaction);
        return;
        const email = ((_transaction_billing = transaction.billing) === null || _transaction_billing === void 0 ? void 0 : _transaction_billing.email) || "N/A";
        const currency = (transaction.currency || "USD").toString();
        (0, $2hYdk.default).notify({
            transactionEvent: {
                id: transactionId.toString(),
                total: total,
                tax: parseFloat(transaction.total_tax || transaction.tax) || 0,
                shipping: parseFloat(transaction.shipping_total || transaction.shipping) || 0,
                city: (((_transaction_billing1 = transaction.billing) === null || _transaction_billing1 === void 0 ? void 0 : _transaction_billing1.city) || "N/A").toString(),
                state: (((_transaction_billing2 = transaction.billing) === null || _transaction_billing2 === void 0 ? void 0 : _transaction_billing2.state) || "N/A").toString(),
                country: (((_transaction_billing3 = transaction.billing) === null || _transaction_billing3 === void 0 ? void 0 : _transaction_billing3.country) || "N/A").toString(),
                currency: currency,
                userId: email,
                items: products.map((product)=>{
                    const { name: name, product_id: product_id, sku: sku, total: total, quantity: quantity } = product;
                    // Divide by the float quantity so fractional lines keep the true
                    // unit price; a parseable zero stays zero, not a phantom unit.
                    const parsedQuantity = parseInt(quantity);
                    const itemQuantity = Number.isNaN(parsedQuantity) ? 1 : parsedQuantity;
                    return {
                        orderId: transactionId.toString(),
                        sku: (product_id || sku).toString(),
                        name: (name || "N/A").toString(),
                        category: "N/A",
                        unitPrice: (parseFloat(total) || 0) / (parseFloat(quantity) || 1),
                        quantity: itemQuantity,
                        currency: currency
                    };
                })
            }
        });
    } catch (error) {
    // logger.error("WooCommerce: failed to emit transaction", error);
    }
};
var $6380d2989ec014a0$export$2e2bcd8739ae039 = $6380d2989ec014a0$var$woocommerceDataSource;

});
parcelRegister("gDdCy", function(module, exports) {

$parcel$export(module.exports, "tryParseJSONObject", function () { return $3314a60fcd51e41f$export$8b0f5bf83db88e; });

var $lwczO = parcelRequire("lwczO");
const $3314a60fcd51e41f$export$8b0f5bf83db88e = (event)=>{
    try {
        if (typeof event === "object") return event;
        if (typeof event === "string") return JSON.parse(event);
    } catch (e) {
        (0, $lwczO.default).error("Error parsing event:", e);
    }
    return event;
};

});


})();
//# sourceMappingURL=woocommerce.b3361db4.js.map
